import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'token', 'csvButton' ]
  static values = {
    cookieName: { type: String, default: 'csv_download' },
    timeout: { type: Number, default: 120000 }
  }

  disconnect() {
    this.clearTimers()
  }

  /*
   * [CSVダウンロードボタン送信のdisable制御の流れ]
   * - 検索ボタンの送信は何もしない
   * - CSVダウンロードボタンの送信は、cookieをクリアして、watchを開始する
   *   - トークン（Date.now()）を隠しフィールド csv_download_token に入れる。この値がフォームと一緒にサーバーへ送られる
   *   - 前回の Cookie が残っていると「もう終わった」と誤判定するので、先に消す
   *   - disabled は setTimeout(..., 0) で遅らせる。クリック直後にdisableすると、ブラウザが送信自体をキャンセルすることがあるため
   * - サーバーが完了の合図を返す  
   *   - CSV ファイルと同時に csv_download=<送られてきたトークン> をセット
   * - watchで以下を監視して解除する
   *   - Cookie 監視: 300msごとに csv_download が今回のトークンと一致 
   *   - タイムアウト: 120秒後にタイムアウト
   */
  start(event) {
    const submitter = event.submitter || document.activeElement
    if (submitter !== this.csvButtonTarget) return

    const token = Date.now().toString()
    this.tokenTarget.value = token
    this.expectedToken = token
    this.clearCookie()

    window.setTimeout(() => {
      this.disableButtons()
      this.watch()
    }, 0)
  }

  watch() {
    this.clearTimers()
    this.pollId = window.setInterval(() => {
      if (this.cookieValue() === this.expectedToken) this.finish()
    }, 300)
    this.timeoutId = window.setTimeout(() => this.finish(), this.timeoutValue)
  }

  finish() {
    this.clearTimers()
    this.clearCookie()
    this.enableButtons()
  }

  disableButtons() {
    this.submitButtons().forEach((button) => { button.disabled = true })
  }

  enableButtons() {
    this.submitButtons().forEach((button) => { button.disabled = false })
  }

  submitButtons() {
    return this.element.querySelectorAll('input[type="submit"], button[type="submit"]')
  }

  cookieValue() {
    const prefix = `${this.cookieNameValue}=`
    const cookie = document.cookie.split('; ').find((entry) => entry.startsWith(prefix))
    return cookie ? decodeURIComponent(cookie.slice(prefix.length)) : null
  }

  clearCookie() {
    document.cookie = `${this.cookieNameValue}=; max-age=0; path=/`
  }

  clearTimers() {
    if (this.pollId) window.clearInterval(this.pollId)
    if (this.timeoutId) window.clearTimeout(this.timeoutId)
    this.pollId = null
    this.timeoutId = null
  }
}
